export default el => {
  const y = window.pageYOffset;

  el.setAttribute('tabindex', '-1');
  el.focus(); // { preventScroll: true } not supported in Safari
  el.removeAttribute('tabindex', '-1');

  window.scrollTo(0, y);
};
